/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function _updateProductVariantImages() {
  var ProductMediaVariantGroup = $('#product_media_slider .product__media-list-wrapper .product__media-list .product__media-item');
  var ProductMediaGridHTML = '';
  var ProductDetailPopupHTML = '';
  var FirstImageHTML = '';
  var ImageHTML = '';
  var VideoHTML = '';

  ProductMediaVariantGroup.each(function(i) {
    var that = $(this);
    
    var IsFiltered = that.hasClass('is-filtered');
    
    if(!IsFiltered) {
      var type = that.data('media-type');
      var src = '';

      if(type == 'image') 
        src = that.find('img').attr('src');
      if(type == 'video')
        src = that.find('template').html();


      if(FirstImageHTML !='' && type == 'image') {
        ImageHTML += '<a href="Javascript:;" class="btn-product-detail col-width-50 col-left" style="padding: 12px 12px 0px 0px;">';
        ImageHTML += '<img class="full-width-100" src="'+src+'">';
        ImageHTML += '</a>';   
      }

      if(FirstImageHTML =='' && type == 'image')
      {
        FirstImageHTML += '<a href="Javascript:;" class="btn-product-detail col-width-50 col-left" style="padding: 12px 12px 0px 0px;">';
        FirstImageHTML += '<img class="full-width-100" src="'+src+'">';
        FirstImageHTML += '</a>';                 
      }

      if(type == 'video') {
        VideoHTML += '<div class="col-left product-introduce-video" style="width: 50%; overflow: hidden; cursor: pointer; padding: 12px 12px 0px 0px;">';
        VideoHTML += src;
        VideoHTML += '</div>';   
      }
    }
  });
  ProductMediaGridHTML = FirstImageHTML + VideoHTML + ImageHTML;

  $('product-media#product_media_grid').html(ProductMediaGridHTML);
  
  $('#product_media_grid').on('click', 'a.btn-product-detail', function(){
    var src = $(this).find('img').attr('src');
    ProductDetailPopupHTML = '<div style="width: 100%; height: 100vh; display: flex; justify-content: center;"><img src="'+src+'" style="height: 100%;"></div>';
    $('#product_detail_popup .content').html(ProductDetailPopupHTML);

    $('#product_detail_popup.overlay').addClass('active');
    $('body').css('overflow', 'hidden');
  });

  $('#product_detail_popup').on('click', 'a.close', function(){
    $('#product_detail_popup.overlay').removeClass('active');
    $('body').css('overflow', 'auto');
  });
};

$('.product__info .product-form__variants').on('click', '.color-swatch-list .color-swatch .color-swatch__item', function() {
     setTimeout(function() { 
      _updateProductVariantImages();
     }, 200);
  });
$(document).ready(function(){
  _updateProductVariantImages();
   
  
});

try {
if($(".bundle-product-container").length) {
updateSwatches();
}

   function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
 $(document).on('click', '.bundle-products-wrapper :input:radio', function() {
  
     $(".form-error").remove();
   
     let $this = $(this);
     let $currentProductWrapper =  $this.closest('.bundle-products-wrapper');
     let _product = $currentProductWrapper.find('[data-product-json]').html();
     _product = JSON.parse(_product);
    
     let option1Value = $currentProductWrapper.find('[data-option="1" ]').find('input:checked').val();
     let option2Value = $currentProductWrapper.find('[data-option="2" ]').find('input:checked').val();
     let _productOptions =$currentProductWrapper.find('[data-product-options-json]').html();
    _productOptions = JSON.parse(_productOptions);
     let productId =  $currentProductWrapper.find('[data-option]').data('product-id');
   
     let selectedVariant = _product.variants.find(variant => variant.option1 == option1Value &&  variant.option2 == option2Value);
   
     if(typeof selectedVariant == "undefined") {

       let option1Variants = _product.variants.filter(variant => variant.option1 == option1Value);
       let option2Variants = _product.variants.filter(variant => variant.option2 == option2Value);
       
       selectedVariant = option1Variants[0];
       
       $currentProductWrapper.find('[data-option="2" ]').find(`input[value="${selectedVariant.option2}"]`).click();
       $currentProductWrapper.find('[data-option="2" ]').find(`input[value="${selectedVariant.option2}"]`).prop("checked", true);
      
       
     }
   
     let $mainCarousel = document.querySelector('product-media#product_media_slider').querySelector("flickity-carousel");
     
     let $mediaWrapper = document.querySelector('product-media#product_media_slider');
   
     if(typeof selectedVariant !== "undefined" && selectedVariant.featured_image) {
       $currentProductWrapper.find('.product-image-wrapper img').attr('src', selectedVariant.featured_image.src);
     }
   
    // Update variant buttons
   _updateDisableSelectors(selectedVariant, _product, _productOptions, $currentProductWrapper);
     // Update product variant id
   
   if(typeof selectedVariant !== "undefined") {
     $(`[name="id[]"][data-product-id="${productId}"]`).val(selectedVariant.id);
   }
   
   // Update prices
   updatePrices(selectedVariant, _product, $currentProductWrapper);
   
   let __bundleProducts = bundleProducts();
   
   const filteredMediaIds = [];
   let shouldReload = false;
   let sweatpantProduct = __bundleProducts.sweatpantProduct;
   let sweatpantSelectedVariant = __bundleProducts.sweatpantSelectedVariant;
   let sweatpantProductOptions = __bundleProducts.sweatpantProductOptions;
   
   let sweaterProduct = __bundleProducts.sweaterProduct;
   let sweaterSelectedVariant = __bundleProducts.sweaterSelectedVariant;
   let sweaterProductOptions = __bundleProducts.sweaterProductOptions;
   
   
   let discountAmount = document.getElementById('bundlePriceContainer').dataset.discountAmount;
   
   updateAtcButtons(sweaterSelectedVariant, sweatpantSelectedVariant);
   updateMainBundlePrice(discountAmount, sweaterSelectedVariant, sweatpantSelectedVariant);
   
   // Sweatpant product
   sweatpantProduct["media"].forEach((media) => {
     var _a;
     let matchMedia2 =  typeof sweatpantSelectedVariant !== "undefined" && sweatpantSelectedVariant["featured_media"] && media["id"] === sweatpantSelectedVariant["featured_media"]["id"];
     if ((_a = media["alt"]) == null ? void 0 : _a.includes("#")) {
       shouldReload = true;
       if (!matchMedia2) {
         const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");

         sweatpantProductOptions.forEach((option) => {
           if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
             if (typeof sweatpantSelectedVariant !== "undefined" && sweatpantSelectedVariant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
               filteredMediaIds.push(media["id"]);
             }
           }
         });
       }
     }
   });

   // Sweater product
   sweaterProduct["media"].forEach((media) => {
     var _a;
     let matchMedia2 = typeof sweaterSelectedVariant !== "undefined" && sweaterSelectedVariant["featured_media"] && media["id"] === sweaterSelectedVariant["featured_media"]["id"];
     if ((_a = media["alt"]) == null ? void 0 : _a.includes("#")) {
       shouldReload = true;
       if (!matchMedia2) {
         const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
         
        sweaterProductOptions.forEach((option) => {
           if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
             if (typeof sweaterSelectedVariant !== "undefined" && sweaterSelectedVariant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
               filteredMediaIds.push(media["id"]);
             }
           }
         });
       }
     }
   });
   

      
   const currentlyFilteredIds = [...new Set(Array.from($mediaWrapper.querySelectorAll(".is-filtered[data-media-id]")).map((item) => parseInt(item.getAttribute("data-media-id"))))];
   
   if (currentlyFilteredIds.some((value) => !filteredMediaIds.includes(value))) {
     
     // Sweatpant
      var selectedMediaId = typeof sweatpantSelectedVariant !== "undefined" && sweatpantSelectedVariant["featured_media"] ? sweatpantSelectedVariant["featured_media"]["id"] : sweatpantProduct["media"].map((item) => item.id).filter((item) => !filteredMediaIds.includes(item))[0];
     Array.from($mediaWrapper.querySelectorAll("[data-media-id]")).forEach((item) => {
       item.classList.toggle("is-filtered", filteredMediaIds.includes(parseInt(item.getAttribute("data-media-id"))));
       item.classList.toggle("is-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
       item.classList.toggle("is-initial-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
     });
     
     // Sweater
     var selectedMediaId = typeof sweaterSelectedVariant !== "undefined" && sweaterSelectedVariant["featured_media"] ? sweaterSelectedVariant["featured_media"]["id"] : sweaterProduct["media"].map((item) => item.id).filter((item) => !filteredMediaIds.includes(item))[0];
     Array.from($mediaWrapper.querySelectorAll("[data-media-id]")).forEach((item) => {
       item.classList.toggle("is-filtered", filteredMediaIds.includes(parseInt(item.getAttribute("data-media-id"))));
       item.classList.toggle("is-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
       item.classList.toggle("is-initial-selected", selectedMediaId === parseInt(item.getAttribute("data-media-id")));
     });
     
     $mainCarousel.reload();
   } else {
     
   if (!selectedVariant["featured_media"]) {
       return;
   }
   
    $mainCarousel.select(`[data-media-id="${selectedVariant["featured_media"]["id"]}"]`);
   }
  
  });

  // $(document).ready(function(){
  //   let atcButton = document.getElementById("AddToCart");
  // }

document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let form = event.target;
  let belowAtcText = document.getElementById('below_atc_section');
  let variantTitle = variant.title;
  var atcLineTwo = document.createElement('span');
  atcLineTwo.id = "atc-public_title";
  atcLineTwo.innerText = variantTitle;
  let atcButton = document.getElementById("AddToCart");

  console.log("variant.available " + variant.available);
  console.log(atcLineTwo);

});

$(document).on('click', '#AddBundleToCart', function(e) {
  
  $(".form-error").remove();
  
  if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
    return;
  }
  
  e.preventDefault();
  
  let $this= $(this);
  $this.attr("disabled", "disabled");
  $this.attr("aria-busy", "true");
  
  _onSubmit($this);
 
});
$(document).on('click', '#completeTheSetButton', function(e) {

    $(".form-error").remove();

    if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
      return;
    }

    e.preventDefault();

    let $this= $(this);
    $this.attr("disabled", "disabled");
    $this.attr("aria-busy", "true");
    ga('send', 'event', 'PDP Links', 'click', 'add set to cart');
    _onSubmit($this);

  });
function updatePrices(selectedVariant, _product, $currentProductWrapper) {

    let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    let $priceList = $currentProductWrapper.find(".price-list");
    let $discountPrice = $priceList.data("discounted-price");
    let $discountAmt = $priceList.data("discount-amount");
    let $priceHTML = "";
    if(selectedVariant.price > $discountPrice) {
    
      $priceHTML += `<span class="price price--highlight price--large">
            <span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>

${formatMoney((selectedVariant.price - $discountAmt), currencyFormat)}
            
          </span>

          <span class="price price--compare">
<span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>
${formatMoney(selectedVariant.price, currencyFormat)}
           
          </span>`
    } else {
    
     $priceHTML += `<span class="price price--large">
            <span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatMoney(selectedVariant.price, currencyFormat)} </span>`;
    }


   if (selectedVariant["unit_price_measurement"]) {
    
     let display = selectedVariant["unit_price_measurement"] ? "block": "none";
      let referenceValue = "";
     $priceHTML += `<div class="price text--subdued" style="display: ${display}">
            <div class="unit-price-measurement">
              <span class="unit-price-measurement__price">${formatMoney(selectedVariant.unit_price, currencyFormat)}</span>
              <span class="unit-price-measurement__separator">/</span>`;
     

               if (selectedVariant["unit_price_measurement"]["reference_value"] !== 1) {
                $priceHTML += `<span class="unit-price-measurement__reference-value">${selectedVariant["unit_price_measurement"]["reference_value"]}</span>
             
              <span class="unit-price-measurement__reference-unit">${selectedVariant["unit_price_measurement"]["reference_unit"]}</span>`;
  }
              
     $priceHTML += `</div>
          </div>`;
    }
 
    $priceList.html($priceHTML);
    
  }
function updateAtcButtonSet() {

  let $addButton = $("#completeTheSetButton");
  let addToCartText = window.themeVariables.strings.productFormAddToCartSet;
  let soldoutText =  window.themeVariables.strings.setSelectionUnavailableHtml;//"Selection unavailable<br>Choose a different size or color";
  
  let setAvailable = true;
    let setProducts = $(".complete-the-set-item");

    let setSalePrice = 0; 
    let setListPrice = 0; 
    Array.from(setProducts).forEach(item => {

      let $setItemObject = $(item);
      let setProduct = $setItemObject.find('[data-product-json]').html();
      setProduct = JSON.parse(setProduct);
      let setOption1Value = $setItemObject.find('[data-option="1" ]').find('input:checked').val();
      let setOption2Value = $setItemObject.find('[data-option="2" ]').find('input:checked').val();
      let setProductOptions = $setItemObject.find('[data-product-options-json]').html();
      setProductOptions = JSON.parse(setProductOptions);
      let setProductId =  $setItemObject.find('[data-option]').data('product-id');
      let setSelectedVariant = setProduct.variants.find(variant => variant.option1 == setOption1Value &&  variant.option2 == setOption2Value);

      if(!setSelectedVariant.available) {
      
        setAvailable = false;
      }
    });
    
  if(!setAvailable) {
  
    $addButton.attr("disabled", true);
    $addButton.html(soldoutText);
    
    $addButton.removeClass('button--primary').addClass('button--ternary')
    
  } else {
  
    $addButton.removeAttr("disabled");
    $addButton.html(addToCartText);
    $addButton.addClass('button--primary').removeClass('button--ternary')
     
  }
}
function updateAtcButtons(sweaterSelectedVariant, sweatpantSelectedVariant) {

  let $addButton = $("#AddBundleToCart");
  let addToCartText = window.themeVariables.strings.productFormAddToCartBundle;
  let soldoutText =  window.themeVariables.strings.productFormSoldOut;
  
  if(!(typeof sweaterSelectedVariant !== "undefined" && sweaterSelectedVariant.available) || ! (typeof sweaterSelectedVariant !== "undefined" && sweatpantSelectedVariant.available)) {
  
    $addButton.attr("disabled", true);
    $addButton.find(".loader-button__text").html(soldoutText);

    $addButton.removeClass('button--primary').addClass('button--ternary')
    
  } else {
  
    $addButton.removeAttr("disabled");
    $addButton.find(".loader-button__text").html(addToCartText);
    $addButton.addClass('button--primary').removeClass('button--ternary')
     
  }
}
function updateMainBundlePrice(discountAmount, sweaterSelectedVariant, sweatpantSelectedVariant) {
    let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    let bundlePriceContainer = document.getElementById('bundlePriceContainer');
    let sweaterPrice = sweaterSelectedVariant.price;
    let sweatpantPrice = sweatpantSelectedVariant.price;
    let bundleSalePrice = 0; 
    let bundleListPrice = 0; 
    bundleSalePrice = sweaterPrice+sweatpantPrice-discountAmount;
    bundleListPrice = sweaterPrice+sweatpantPrice;
//     console.log(bundleSalePrice);
    console.log(formatMoney(bundleSalePrice, currencyFormat));
    console.log(formatMoney(bundleListPrice, currencyFormat));
    
    let bundleDisplaySalePrice = document.getElementById('bundleSalePrice');
    let bundleDisplayListPrice = document.querySelector('.bundleListPrice');
    
    bundleDisplaySalePrice.innerHTML = formatMoney(bundleSalePrice, currencyFormat);
    bundleDisplayListPrice.innerHTML = "<span>("+formatMoney(bundleListPrice, currencyFormat)+" value)";
  }
function updateMainSetPrice(discountAmount) {
    let currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
    let setPriceContainer = document.getElementById('product-set-total');
    let setProducts = $(".complete-the-set-item");
    
    let setSalePrice = 0; 
    let setListPrice = 0; 
    Array.from(setProducts).forEach(item => {

      let $setItemObject = $(item);
      let setProduct = $setItemObject.find('[data-product-json]').html();
      setProduct = JSON.parse(setProduct);
      let setOption1Value = $setItemObject.find('[data-option="1" ]').find('input:checked').val();
      let setOption2Value = $setItemObject.find('[data-option="2" ]').find('input:checked').val();
      let setProductOptions = $setItemObject.find('[data-product-options-json]').html();
      setProductOptions = JSON.parse(setProductOptions);
      let setProductId =  $setItemObject.find('[data-option]').data('product-id');
      let setSelectedVariant = setProduct.variants.find(variant => variant.option1 == setOption1Value &&  variant.option2 == setOption2Value);

      setListPrice += setSelectedVariant.compare_at_price;
      setSalePrice += setSelectedVariant.price;
      
    });

    let discountAmt = 0;
    let dataDiscountAmt = parseInt(setPriceContainer.getAttribute('data-discount-amount'));
    discountAmt += dataDiscountAmt;
    
    let discountedPrice = setSalePrice - discountAmt;

    console.log("setListPrice = " + setListPrice);
    console.log("setSalePrice = " + setSalePrice);
    console.log("discountedPrice = " + discountedPrice);
    
    let $setPriceHtml = "";
    if(setSalePrice > discountedPrice) {
    
      $setPriceHtml += `<span class="price price--highlight price--large total-amount">${formatMoney(discountedPrice, currencyFormat)}&nbsp;</span>`;
       $setPriceHtml += `<span class="price price--compare total-amount">${formatMoney(setSalePrice, currencyFormat)}</span>`;
    } else {

       $setPriceHtml += `<span class="price price--large total-amount">${formatMoney(setSalePrice, currencyFormat)}</span>`;
    }

    $(".prices-total-wrapper").html($setPriceHtml);
  }
function updateSwatches() {

   let _bundleProducts = bundleProducts();
   
   let sweaterProduct = _bundleProducts.sweaterProduct;
   let sweaterSelectedVariant = _bundleProducts.sweaterSelectedVariant;
   let sweaterProductOptions = _bundleProducts.sweaterProductOptions;
   let $sweaterProductWrapper = _bundleProducts.sweaterProductWrapper;
  
  let sweatpantProduct = _bundleProducts.sweatpantProduct;
  let sweatpantSelectedVariant = _bundleProducts.sweatpantSelectedVariant;
  let sweatpantProductOptions = _bundleProducts.sweatpantProductOptions;
  let $sweatpantProductWrapper = _bundleProducts.sweatpantProductWrapper;

   // Update variant buttons for sweater
   _updateDisableSelectors(sweaterSelectedVariant, sweaterProduct, sweaterProductOptions, $sweaterProductWrapper);
  
    // Update variant buttons for sweatpant
   _updateDisableSelectors(sweatpantSelectedVariant, sweatpantProduct, sweatpantProductOptions, $sweatpantProductWrapper);
  
  updateAtcButtons(sweaterSelectedVariant, sweatpantSelectedVariant);
  
}
function bundleProducts() {

  let $sweaterProductWrapper = $('[data-product="sweater"]'); 
  let sweaterProduct = $sweaterProductWrapper.find('[data-product-json]').html();
  sweaterProduct = JSON.parse(sweaterProduct);
  let sweaterOption1Value = $sweaterProductWrapper.find('[data-option="1" ]').find('input:checked').val();
  let sweaterOption2Value = $sweaterProductWrapper.find('[data-option="2" ]').find('input:checked').val();
  let sweaterProductOptions = $sweaterProductWrapper.find('[data-product-options-json]').html();
  sweaterProductOptions = JSON.parse(sweaterProductOptions);
  let sweaterProductId =  $sweaterProductWrapper.find('[data-option]').data('product-id');
  let sweaterSelectedVariant = sweaterProduct.variants.find(variant => variant.option1 == sweaterOption1Value &&  variant.option2 == sweaterOption2Value);

  let $sweatpantProductWrapper = $('[data-product="sweatpant"]'); 
  let sweatpantProduct = $sweatpantProductWrapper.find('[data-product-json]').html();
  sweatpantProduct = JSON.parse(sweatpantProduct);
  let sweatpantOption1Value = $sweatpantProductWrapper.find('[data-option="1" ]').find('input:checked').val();
  let sweatpantOption2Value = $sweatpantProductWrapper.find('[data-option="2" ]').find('input:checked').val();
  let sweatpantProductOptions = $sweatpantProductWrapper.find('[data-product-options-json]').html();
  sweatpantProductOptions = JSON.parse(sweatpantProductOptions);
  let sweatpantProductId =  $sweatpantProductWrapper.find('[data-option]').data('product-id');
  let sweatpantSelectedVariant = sweatpantProduct.variants.find(variant => variant.option1 == sweatpantOption1Value &&  variant.option2 == sweatpantOption2Value);

  return {
    sweaterSelectedVariant: sweaterSelectedVariant,
    sweatpantSelectedVariant: sweatpantSelectedVariant,
    sweaterProduct: sweaterProduct,
    sweatpantProduct: sweatpantProduct,
    sweaterProductOptions: sweaterProductOptions,
    sweatpantProductOptions: sweatpantProductOptions,
    sweaterProductWrapper: $sweaterProductWrapper,
    sweatpantProductWrapper: $sweatpantProductWrapper
    
    
  }
  
}
async function _onSubmit($this) {
  
  let $form = $this.closest('form');
  
 const productForm = new FormData($form[0]);
  productForm.append("sections", ["mini-cart"]);
  productForm.delete("option1");
  productForm.delete("option2");
  productForm.delete("option3");

  const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
    body: productForm,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  });
  
  const responseJson = await response.json();
  
  $this.removeAttr("disabled");
  $this.removeAttr("aria-busy");
  
  if (response.ok) {
 
    fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
     const cartContent = await response2.json();
    document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
      bubbles: true,
      detail: {
        cart: cartContent
      }
    }));
  });
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
    bubbles: true,
    detail: {
      cart: responseJson,
      openMiniCart: window.themeVariables.settings.cartType === "drawer" && $form.closest(".drawer") === null
    }
  }));

  $(".header__icon-wrapper[href='/cart']")[0].click();
} else {

  $(`<div class="form-error" style="color:red">${responseJson.description}</div>`).insertAfter(document.getElementById('AddBundleToCart'));
 
}

}
const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
  let selectorType = selector.getAttribute("data-selector-type"), cssSelector = "";
  switch (selectorType) {
    case "color":
      cssSelector = `.color-swatch:nth-child(${valueIndex + 1})`;
      break;
    case "variant-image":
      cssSelector = `.variant-swatch:nth-child(${valueIndex + 1})`;
      break;
    case "block":
      cssSelector = `.block-swatch:nth-child(${valueIndex + 1})`;
      break;
    case "dropdown":
      cssSelector = `.combo-box__option-item:nth-child(${valueIndex + 1})`;
      break;
  }


  selector.querySelectorAll(cssSelector).forEach(item => {

    item.toggleAttribute("hidden", !hasAtLeastOneCombination);
    if (this.hideSoldOutVariants) {
      item.toggleAttribute("hidden", !available);
    } else {
      item.classList.toggle("is-disabled", !available);
    }

  });

};
function _updateDisableSelectors(selectedVariant, product, productOptions, $productWrapper) {

  let optionSelectors = Array.from($productWrapper.find("[data-selector-type]"));
  
  if (!selectedVariant) {
    return;
  }
  const applyClassToSelector = (selector, valueIndex, available, hasAtLeastOneCombination) => {
    let selectorType = selector.getAttribute("data-selector-type"), cssSelector = "";
    switch (selectorType) {
      case "color":
        cssSelector = `.color-swatch:nth-child(${valueIndex + 1})`;
        break;
      case "variant-image":
        cssSelector = `.variant-swatch:nth-child(${valueIndex + 1})`;
        break;
      case "block":
        cssSelector = `.block-swatch:nth-child(${valueIndex + 1})`;
        break;
      case "dropdown":
        cssSelector = `.combo-box__option-item:nth-child(${valueIndex + 1})`;
        break;
    }


    selector.querySelectorAll(cssSelector).forEach(item => {

      item.toggleAttribute("hidden", !hasAtLeastOneCombination);
      if (this.hideSoldOutVariants) {
        item.toggleAttribute("hidden", !available);
      } else {
        item.classList.toggle("is-disabled", !available);
      }

    });

  };

  if (optionSelectors && optionSelectors[0]) {
    productOptions[0]["values"].forEach((value, valueIndex) => {
      const hasAtLeastOneCombination = product["variants"].some((variant) => variant["option1"] === value && variant), hasAvailableVariant = product["variants"].some((variant) => variant["option1"] === value && variant["available"]);

      applyClassToSelector(optionSelectors[0], valueIndex, hasAvailableVariant, hasAtLeastOneCombination);
      if (optionSelectors[1]) {
        productOptions[1]["values"].forEach((value2, valueIndex2) => {
          const hasAtLeastOneCombination2 = product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant), hasAvailableVariant2 = product["variants"].some((variant) => variant["option2"] === value2 && variant["option1"] === selectedVariant["option1"] && variant["available"]);
          applyClassToSelector(optionSelectors[1], valueIndex2, hasAvailableVariant2, hasAtLeastOneCombination2);
          if (optionSelectors[2]) {
            productOptions[2]["values"].forEach((value3, valueIndex3) => {
              const hasAtLeastOneCombination3 = product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant), hasAvailableVariant3 = product["variants"].some((variant) => variant["option3"] === value3 && variant["option1"] === selectedVariant["option1"] && variant["option2"] === selectedVariant["option2"] && variant["available"]);
              applyClassToSelector(optionSelectors[2], valueIndex3, hasAvailableVariant3, hasAtLeastOneCombination3);
            });
          }
        });
      }
    });
  }
}
} catch(e) {

  console.log(e);
}
$(document).on('click', '.complete-the-set-item :input:radio', function() {
  
     $(".form-error").remove();
   
     let $this = $(this);
     let $currentProductWrapper =  $this.closest('.complete-the-set-item');
     let _product = $currentProductWrapper.find('[data-product-json]').html();
     _product = JSON.parse(_product);
    
     let option1Value = $currentProductWrapper.find('[data-option="1" ]').find('input:checked').val();
     let option2Value = $currentProductWrapper.find('[data-option="2" ]').find('input:checked').val();
     let _productOptions =$currentProductWrapper.find('[data-product-options-json]').html();
    _productOptions = JSON.parse(_productOptions);
     let productId =  $currentProductWrapper.find('[data-option]').data('product-id');
   
     let selectedVariant = _product.variants.find(variant => variant.option1 == option1Value &&  variant.option2 == option2Value);
   
     if(typeof selectedVariant == "undefined") {

       let option1Variants = _product.variants.filter(variant => variant.option1 == option1Value);
       let option2Variants = _product.variants.filter(variant => variant.option2 == option2Value);
       
       selectedVariant = option1Variants[0];
       
       $currentProductWrapper.find('[data-option="2" ]').find(`input[value="${selectedVariant.option2}"]`).click();
       $currentProductWrapper.find('[data-option="2" ]').find(`input[value="${selectedVariant.option2}"]`).prop("checked", true);
      
       
     }
   
       if(typeof selectedVariant !== "undefined" && selectedVariant.featured_image) {
         
       $currentProductWrapper.find('.product-image-wrapper img').attr('src', selectedVariant.featured_image.src);
     }
  
    // Update variant buttons
    _updateDisableSelectors(selectedVariant, _product, _productOptions, $currentProductWrapper);
     // Update product variant id
   
   if(typeof selectedVariant !== "undefined") {
     $('.ih-pdp-complete-the-set').find(`[name="id[]"][data-product-id="${productId}"]`).val(selectedVariant.id);
   }
   
  let discountAmount = document.getElementById('product-set-total').dataset.discountAmount;
  
  
   // Update prices
   updatePrices(selectedVariant, _product, $currentProductWrapper);
   
  updateAtcButtonSet();
  updateMainSetPrice(discountAmount);

  });

if($('.complete-the-set-item').length) {

      let setProducts = $(".complete-the-set-item");
    Array.from(setProducts).forEach(item => {

      let $setItemObject = $(item);
      let setProduct = $setItemObject.find('[data-product-json]').html();
      setProduct = JSON.parse(setProduct);
      let setOption1Value = $setItemObject.find('[data-option="1" ]').find('input:checked').val();
      let setOption2Value = $setItemObject.find('[data-option="2" ]').find('input:checked').val();
      let setProductOptions = $setItemObject.find('[data-product-options-json]').html();
      setProductOptions = JSON.parse(setProductOptions);
      let setProductId =  $setItemObject.find('[data-option]').data('product-id');
      let setSelectedVariant = setProduct.variants.find(variant => variant.option1 == setOption1Value &&  variant.option2 == setOption2Value);

       // Update variant buttons
    _updateDisableSelectors(setSelectedVariant, setProduct, setProductOptions, $setItemObject);
      
    });
    
}

/* Event snippet for Add to cart - Shopify Website (10/23) conversion page  */
document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let variantPrice = variant.price;
  gtag('event', 'conversion', {'send_to': 'AW-975022672/v01rCL3a6-oYENDU9tAD'});
});
                                             
   
 
$(document).on( 'click', 'button[name="checkout"]', function () { 
    var totalCartValue = $('input#google-ads-cart-total').val();
    gtag('event', 'conversion', {
      'send_to': 'AW-975022672/Xwj1CMDa6-oYENDU9tAD',
      'value': totalCartValue,
      'currency': 'USD'
    });
});


window.hackyUpdateCartProgressBar = function(){ 
  

  // clone and prepend the #ic--progress inside .heading-container to the  .drawer__content div
var progressClone = $('#feat-packs-collection #ic--progress').get(0).outerHTML;



if (!$('#ic--feat-pack-drawer-container #ic--progress--inline-cart-heading').length) {
    var progressCartHeading = `<div id="ic--progress--inline-cart-heading"><span>Your Feat Pack Rewards</span></div>`;
    $('#ic--feat-pack-drawer-container').prepend(progressCartHeading);
}


$('#ic--feat-pack-drawer-progress').html(progressClone);

if($('cart-count').text() == "0"){
  $("div#ic--feat-pack-drawer-container").hide();
} else {
  $("div#ic--feat-pack-drawer-container").show();
  $('#ic--feat-pack-drawer-progress').slideDown();
}
}

window.applyDiscountCodeTrick = function(discount){ 
  // Applies discount using hidden iframe to the checkout session
  $('cart-drawer#mini-cart').addClass('ic--cart-loading');
  $('#ic--feat-pack-drawer-progress').slideUp();
  var shopDomain = "feat-socks.myshopify.com";
  var discountApplyUrl = "https://" + shopDomain + "/discount/" + discount;
    
  var i = document.createElement('iframe');
  i.style.display = 'none';
  i.onload = function() { i.parentNode.removeChild(i); 

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    
    $('cart-drawer#mini-cart').removeClass('ic--cart-loading');
    
    setTimeout(function(){ 
      window.hackyUpdateCartProgressBar();
    }, 400);

  };
  i.src=discountApplyUrl;
  document.body.appendChild(i);
}

